import { put, call } from 'redux-saga/effects'; 

import { crewAvailabilityReportList,crewAvailSummaryReportList,cancelReasonList,addRemoveVehicleShift,removeAffVehicle,addAffVehicle,availableAffVehicle,invoicePreview,updateInvoice,listInvoice,addRemoveVehicle,sendEventMessage,listEventMessages,eventList,invoiceList,eventAdd,eventEdit,eventUpdate,quoteAccept,quoteDecline,eventDelete,shiftAdd,eventClientDetails,quoteSummaryList,quotePreview,eventSummaryList,eventGetChiefCrewCount,quoteSendtoClient,eventUserActionLogs,shiftIndividualDetails,shiftList,shiftUpdate,quoteDownload,eventClientAffiliateList,shiftDelete,shiftEdit,quoteRequest,eventCalendarList,shiftSummary,shiftGetDetails,shiftScheduleList,shiftScheduleCrew,shiftSkillCrewList,shiftScheduleCrewRequest,scheduleDateView,scheduleCrewView,eventCancel,shiftCancel,filterClientsList,shiftsFilterEventsList,shiftsFilterShiftsList,shiftsFilterLocationsList,eventsFilterEventsList,eventsFilterLocationsList,getNextShiftSeqNumber,eventComplete,invoiceDownload,invoiceSendtoClient,scheduleShiftCrew,editQuoteDiscount,filterAffiliatesList,shiftSummaryAllCrew,listEventShifts,listEventShiftCrew,schedulesDateViewCalendar,schedDateViewCalendarDate,shiftCrewDownload,shiftTimeChangeRequest,getUnallocatedShiftsCount,eventAffiliateDetails, clientDepartmentsByEventId, shiftCalendarEventsList, shiftCalendarEventShiftsList, generateInvoice, eventShiftsStaffListPDFDownload, shiftCalcDistanceDeptLoc} from '../services/eventService';

import { eventClientList } from '../services/clientService';
import { eventLocationList } from '../services/settings/affiliates/locationService';
import {assUserList} from '../services/assUserService';

import * as types from '../actions';

export function* eventListSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(eventList, payload);
      yield put({ type: types.EVENT_LIST_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.EVENT_LIST_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
    }
}

export function* eventListDownloadSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(eventList, payload);
    yield put({ type: types.EVENT_LIST_DOWNLOAD_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.EVENT_LIST_DOWNLOAD_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
  }
}

export function* invoiceListDownloadSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(invoiceList, payload);
    yield put({ type: types.INVOICE_LIST_DOWNLOAD_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.INVOICE_LIST_DOWNLOAD_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
  }
}



export function* eventClientListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(eventClientList, payload);
    yield put({ type: types.QUOTE_CLIENT_LIST_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.QUOTE_CLIENT_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* quoteEventLocationListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(eventLocationList, payload);
    yield put({ type: types.QUOTE_EVENT_LOCATION_LIST_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.QUOTE_EVENT_LOCATION_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* eventAddSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(eventAdd, payload);
    yield put({ type: types.EVENT_ADD_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.EVENT_ADD_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}
export function* eventEditSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(eventEdit, payload);
    yield put({ type: types.EVENT_EDIT_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.EVENT_EDIT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}
export function* eventUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(eventUpdate, payload);
    yield put({ type: types.EVENT_UPDATE_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.EVENT_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* eventDeleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(eventDelete, payload);
    yield put({ type: types.EVENT_DELETE_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.EVENT_DELETE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* eventCancelSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(eventCancel, payload);
    yield put({ type: types.EVENT_CANCEL_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.EVENT_CANCEL_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}


export function* quoteAcceptSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(quoteAccept, payload);
    yield put({ type: types.QUOTE_ACCEPT_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.QUOTE_ACCEPT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}
export function* quoteDeclineSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(quoteDecline, payload);
    yield put({ type: types.QUOTE_REJECT_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.QUOTE_REJECT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* quoteRequestSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(quoteRequest, payload);
    yield put({ type: types.QUOTE_REQUEST_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.QUOTE_REQUEST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* quoteAssUserListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(assUserList, payload);
    yield put({ type: types.QUOTE_ASS_USER_LIST_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.QUOTE_ASS_USER_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}


export function* shiftAddSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(shiftAdd, payload);
    yield put({ type: types.SHIFT_ADD_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.SHIFT_ADD_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* shiftCancelSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(shiftCancel, payload);
    yield put({ type: types.SHIFT_CANCEL_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.SHIFT_CANCEL_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* eventClientDetailsSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(eventClientDetails, payload);
    yield put({ type: types.EVENT_CLIENT_DETAILS_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.EVENT_CLIENT_DETAILS_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* generateInvoiceSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(generateInvoice, payload);
    yield put({ type: types.GENERATE_INVOICE_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.GENERATE_INVOICE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* eventAffiliateDetailsSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(eventAffiliateDetails, payload);
    yield put({ type: types.EVENT_AFFILIATE_DETAILS_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.EVENT_AFFILIATE_DETAILS_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* quoteSummarySaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(quoteSummaryList, payload);
    yield put({ type: types.EVENT_QUOTE_SUMMARY_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.EVENT_QUOTE_SUMMARY_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* eventQuotePreviewSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(quotePreview, payload);
    yield put({ type: types.EVENT_QUOTE_PREVIEW_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.EVENT_QUOTE_PREVIEW_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* eventSummarySaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(eventSummaryList, payload);
    yield put({ type: types.EVENT_SUMMARY_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.EVENT_SUMMARY_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* eventGetCrewChiefCountSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(eventGetChiefCrewCount, payload);
    yield put({ type: types.EVENT_CREW_CHIEF_COUNT_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.EVENT_CREW_CHIEF_COUNT_ERROR, error });

  }finally{
    yield put({ type: types.HIDE_LOADER})
  }
}

export function* shiftIndividualDetailsSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(shiftIndividualDetails, payload);
    yield put({ type: types.SHIFT_INDIVIDUAL_DETAILS_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.SHIFT_INDIVIDUAL_DETAILS_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* shiftEditSaga(payload) { 
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(shiftEdit, payload);
    yield put({ type: types.SHIFT_EDIT_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.SHIFT_EDIT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* quoteSendtoClientSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(quoteSendtoClient, payload);
    yield put({ type: types.QUOTE_SEND_CLIENT_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.QUOTE_SEND_CLIENT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* invoiceSendtoClientSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(invoiceSendtoClient, payload);
    yield put({ type: types.INVOICE_SEND_CLIENT_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.INVOICE_SEND_CLIENT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* eventUserActionLogsSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(eventUserActionLogs, payload);
    yield put({ type: types.QUOTE_USER_ACTION_LOG_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.QUOTE_USER_ACTION_LOG_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* shiftListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(shiftList, payload);
    yield put({ type: types.SHIFT_LIST_SUCCESS, response })
  } catch(error) {
    yield put({ type: types.SHIFT_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* shiftDeleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(shiftDelete, payload);
    yield put({ type: types.SHIFT_DELETE_SUCCESS, response })
  } catch(error) {
    yield put({ type: types.SHIFT_DELETE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* quoteQuickUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(shiftUpdate, payload);
    yield put({ type: types.SHIFT_QUICK_UPDATE_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.SHIFT_QUICK_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* eventShiftUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(shiftUpdate, payload);
    yield put({ type: types.EVENT_SHIFT_UPDATE_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.EVENT_SHIFT_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* quoteDownloadSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(quoteDownload, payload);
    yield put({ type: types.QUOTE_DOWNLOAD_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.QUOTE_DOWNLOAD_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* invoiceDownloadSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(invoiceDownload, payload);
    yield put({ type: types.INVOICE_DOWNLOAD_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.INVOICE_DOWNLOAD_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* eventClientAffiliateListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(eventClientAffiliateList, payload);
    yield put({ type: types.EVENT_CLIENT_AFFILIATE_LIST_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.EVENT_CLIENT_AFFILIATE_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* eventCalendarListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(eventCalendarList, payload);
    yield put({ type: types.EVENTS_CALENDAR_LIST_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.EVENTS_CALENDAR_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* shiftSummarySaga(payload) { // USED IN SHIFT DETAILS SLIDER 
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(shiftSummary, payload);
    yield put({ type: types.SHIFT_SUMMARY_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.SHIFT_SUMMARY_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* shiftSummaryAllCrewSaga(payload) { // USED IN SHIFT DETAILS SLIDER ALL CREW DETAILS 
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(shiftSummaryAllCrew, payload);
    yield put({ type: types.SHIFT_SUMMARY_ALL_CREW_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.SHIFT_SUMMARY_ALL_CREW_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
} 

export function* shiftGetDetailsSaga(payload) { 
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(shiftGetDetails, payload);
    yield put({ type: types.SHIFT_GET_DETAILS_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.SHIFT_GET_DETAILS_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* shiftScheduleListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(shiftScheduleList, payload);
    yield put({ type: types.SHIFT_SCHEDULE_LIST_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.SHIFT_SCHEDULE_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* shiftScheduleCrewSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(shiftScheduleCrew, payload);
    yield put({ type: types.SHIFT_SCHEDULE_CREW_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.SHIFT_SCHEDULE_CREW_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* scheduleShiftCrewSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(scheduleShiftCrew, payload);
    yield put({ type: types.SCHEDULE_SHIFT_CREW_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.SCHEDULE_SHIFT_CREW_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* shiftScheduleCrewRequestSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(shiftScheduleCrewRequest, payload);
    yield put({ type: types.SHIFT_SCHEDULE_CREW_SEND_REQUEST_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.SHIFT_SCHEDULE_CREW_SEND_REQUEST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* shiftSkillCrewListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(shiftSkillCrewList, payload);
    yield put({ type: types.SHIFT_SKILL_CREW_LIST_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.SHIFT_SKILL_CREW_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* scheduleDateViewSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(scheduleDateView, payload); 
    yield put({ type: types.SCHEDULE_DATE_VIEW_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.SCHEDULE_DATE_VIEW_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* scheduleCrewViewSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(scheduleCrewView, payload);
    yield put({ type: types.SCHEDULE_CREW_VIEW_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.SCHEDULE_CREW_VIEW_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
  }
}

export function* filterClientsListSaga(payload) {
  try {
    const response = yield call(filterClientsList, payload);
    yield put({ type: types.FILTER_CLIENTS_LIST_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.FILTER_CLIENTS_LIST_ERROR, error });
  }
}

export function* shiftsFilterEventsListSaga(payload) {
  try {
    const response = yield call(shiftsFilterEventsList, payload);
    yield put({ type: types.SHIFTS_FILTER_EVENTS_LIST_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.SHIFTS_FILTER_EVENTS_LIST_ERROR, error });
  }
} 

export function* shiftsFilterShiftsListSaga(payload) {
  try {
    const response = yield call(shiftsFilterShiftsList, payload);
    yield put({ type: types.SHIFTS_FILTER_SHIFTS_LIST_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.SHIFTS_FILTER_SHIFTS_LIST_ERROR, error });
  }
}  

export function* shiftsFilterLocationsListSaga(payload) {
  try {
    const response = yield call(shiftsFilterLocationsList, payload);
    yield put({ type: types.SHIFTS_FILTER_LOCATIONS_LIST_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.SHIFTS_FILTER_LOCATIONS_LIST_ERROR, error });
  }
} 

export function* eventsFilterEventsListSaga(payload) {
  try {
    const response = yield call(eventsFilterEventsList, payload);
    yield put({ type: types.EVENTS_FILTER_EVENTS_LIST_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.EVENTS_FILTER_EVENTS_LIST_ERROR, error });
  }
} 

export function* eventsFilterLocationsListSaga(payload) {
  try {
    const response = yield call(eventsFilterLocationsList, payload);
    yield put({ type: types.EVENTS_FILTER_LOCATIONS_LIST_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.EVENTS_FILTER_LOCATIONS_LIST_ERROR, error });
  }
} 

export function* getNextShiftSeqNumberSaga(payload) {
  try {
    const response = yield call(getNextShiftSeqNumber, payload);
    yield put({ type: types.SHIFT_SEQ_NUMBER_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.SHIFT_SEQ_NUMBER_ERROR, error });
  }
} 

export function* eventCompleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(eventComplete, payload);
    yield put({ type: types.EVENT_COMPLETE_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.EVENT_COMPLETE_ERROR, error });
  } finally{
    yield put({ type: types.HIDE_LOADER})
  }
}

export function* editQuoteDiscountSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(editQuoteDiscount, payload);
    yield put({ type: types.EVENT_DISCOUNT_EDIT_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.EVENT_DISCOUNT_EDIT_ERROR, error });
  } finally{
    yield put({ type: types.HIDE_LOADER})
  }
}

export function* filterAffiliatesListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(filterAffiliatesList, payload);
    yield put({ type: types.FILTER_AFFILIATE_LIST_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.FILTER_AFFILIATE_LIST_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
  }
}

export function* listEventShiftsSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(listEventShifts, payload);
    yield put({ type: types.EVENT_SHIFTS_LIST_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.EVENT_SHIFTS_LIST_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
  }
} 

export function* listEventShiftCrewSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(listEventShiftCrew, payload);
    yield put({ type: types.EVENT_SHIFT_CREW_LIST_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.EVENT_SHIFT_CREW_LIST_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
  }
} 

export function* schedulesDateViewCalendarSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(schedulesDateViewCalendar, payload);
    yield put({ type: types.SCHEDULE_DATE_VIEW_CALENDAR_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.SCHEDULE_DATE_VIEW_CALENDAR_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
  }
}  

export function* schedDateViewCalendarDateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(schedDateViewCalendarDate, payload);
    yield put({ type: types.SCHED_DATE_VIEW_CALENDAR_DATE_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.SCHED_DATE_VIEW_CALENDAR_DATE_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
  }
}

export function* shiftCrewListDownloadSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(shiftCrewDownload, payload);
    yield put({ type: types.SHIFT_CREW_LIST_DOWNLOAD_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.SHIFT_CREW_LIST_DOWNLOAD_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
  }
}

export function* eventShiftsStaffListPDFDownloadSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(eventShiftsStaffListPDFDownload, payload);
    yield put({ type: types.EVENT_SHIFTS_STAFF_LIST_PDF_DOWNLOAD_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.EVENT_SHIFTS_STAFF_LIST_PDF_DOWNLOAD_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
  }
}

export function* listEventMessagesSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(listEventMessages, payload);
    yield put({ type: types.EVENT_MESSAGES_LIST_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.EVENT_MESSAGES_LIST_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
  }
}
export function* sendEventMessageSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(sendEventMessage, payload);
    yield put({ type: types.SEND_EVENT_MESSAGE_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.SEND_EVENT_MESSAGE_ERROR, error });
   }finally{
    yield put({ type: types.HIDE_LOADER})
  }
}

export function* shiftTimeChangeRequestSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(shiftTimeChangeRequest, payload);
    yield put({ type: types.SHIFT_TIME_CHANGE_REQUEST_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.SHIFT_TIME_CHANGE_REQUEST_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER})
  }
}

export function* getUnallocatedShiftsCountSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER});
    const response = yield call(getUnallocatedShiftsCount, payload);
    yield put({ type: types.UNALLOCATED_SHIFTS_COUNT_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.UNALLOCATED_SHIFTS_COUNT_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER});
  }
}

export function* addRemoveVehicleSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER});
    const response = yield call(addRemoveVehicle, payload);
    yield put({ type: types.ADD_REMOVE_VEHICLE_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.ADD_REMOVE_VEHICLE_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER});
  }
}
export function* addRemoveVehicleShiftSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER});
    const response = yield call(addRemoveVehicleShift, payload);
    yield put({ type: types.ADD_REMOVE_VEHICLE_SHIFT_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.ADD_REMOVE_VEHICLE_SHIFT_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER});
  }
}

export function* listInvoiceSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER});
    const response = yield call(listInvoice, payload);
    yield put({ type: types.LIST_INVOICE_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.LIST_INVOICE_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER});
  }
}
export function* invoicePreviewSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER});
    const response = yield call(invoicePreview, payload);
    yield put({ type: types.INVOICE_PREVIEW_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.INVOICE_PREVIEW_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER});
  }
}

export function* updateInvoiceSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER});
    const response = yield call(updateInvoice, payload);
    yield put({ type: types.UPDATE_INVOICE_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.UPDATE_INVOICE_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER});
  }
}
export function* availableAffVehicleSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER});
    const response = yield call(availableAffVehicle, payload);
    yield put({ type: types.AVAILABLE_AFF_VEHICLE_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.AVAILABLE_AFF_VEHICLE_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER});
  }
}
export function* addAffVehicleSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER});
    const response = yield call(addAffVehicle, payload);
    yield put({ type: types.ADD_AFF_VEHICLE_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.ADD_AFF_VEHICLE_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER});
  }
}
export function* removeAffVehicleSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER});
    const response = yield call(removeAffVehicle, payload);
    yield put({ type: types.REMOVE_AFF_VEHICLE_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.REMOVE_AFF_VEHICLE_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER});
  }
}
export function* addAffVehicleShiftSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER});
    const response = yield call(addAffVehicle, payload);
    yield put({ type: types.ADD_AFF_VEHICLE_SHIFT_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.ADD_AFF_VEHICLE_SHIFT_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER});
  }
}
export function* removeAffVehicleShiftSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER});
    const response = yield call(removeAffVehicle, payload);
    yield put({ type: types.REMOVE_AFF_VEHICLE_SHIFT_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.REMOVE_AFF_VEHICLE_SHIFT_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER});
  }
}
export function* cancelReasonListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER});
    const response = yield call(cancelReasonList, payload);
    yield put({ type: types.CANCELLED_REASON_LIST_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.CANCELLED_REASON_LIST_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER});
  }
}
export function* crewAvailabilityReportSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER});
    const response = yield call(crewAvailabilityReportList, payload);
    yield put({ type: types.CREW_AVAILABILITY_REPORT_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.CREW_AVAILABILITY_REPORT_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER});
  }
} 

export function* clientDepartmentsByEventIdSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER});
    const response = yield call(clientDepartmentsByEventId, payload);
    yield put({ type: types.EVENT_CLIENT_DEPARTMENTS_LIST_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.EVENT_CLIENT_DEPARTMENTS_LIST_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER});
  }
}

export function* crewAvailSummaryReportListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER});
    const response = yield call(crewAvailSummaryReportList, payload);
    yield put({ type: types.CREW_AVAIL_SUMMARY_REPORT_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.CREW_AVAIL_SUMMARY_REPORT_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER});
  }
} 

export function* shiftCalendarEventsListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER});
    const response = yield call(shiftCalendarEventsList, payload);
    yield put({ type: types.SHIFT_CALENDAR_EVENT_LIST_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.SHIFT_CALENDAR_EVENT_LIST_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER});
  }
} 

export function* shiftCalendarEventShiftsListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER});
    const response = yield call(shiftCalendarEventShiftsList, payload);
    yield put({ type: types.SHIFT_CALENDAR_EVENT_SHIFT_LIST_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.SHIFT_CALENDAR_EVENT_SHIFT_LIST_ERROR, error });
  }finally{
    yield put({ type: types.HIDE_LOADER});
  }
} 

export function* shiftCalcDistanceDeptLocSaga(payload) {
  try {
    // yield put({ type: types.SHOW_LOADER});
    const response = yield call(shiftCalcDistanceDeptLoc, payload);
    yield put({ type: types.SHIFT_CALC_DISTANCE_DEPT_LOC_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.SHIFT_CALC_DISTANCE_DEPT_LOC_ERROR, error });
  }finally{
    // yield put({ type: types.HIDE_LOADER});
  }
} 

